export default __webpack_public_path__ + "pgnv-assets/00944349f6905c3690cba811dcb3559a.png";